import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Button } from 'react-bootstrap';

export interface FileDataProps {
  className?: string;
  onChange: (content: string) => void;
}

export const FileData: React.FC<FileDataProps> = (props) => {
  const ref = React.useRef<HTMLInputElement | null>(null);
  const id = uuidv4();
  const [filename, setFilename] = React.useState<string | null>(null);
  const [filesize, setFilesize] = React.useState<number | null>(null);

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(`FileData.handleChange`);
    if (ref.current?.files?.length) {
      const file = ref.current.files[0];
      props.onChange(await file.text());
      setFilename(ref.current.files[0].name);
      setFilesize(ref.current.files[0].size);
    }
  };

  const handleReset = () => {
    setFilename(null);
    setFilesize(null);
  };

  return (
    <>
      {!filename && (
        <Button variant="primary" style={{ padding: 0 }}>
          <label htmlFor={id} style={{ paddingTop: 5, paddingRight: 10, paddingBottom: 5, paddingLeft: 10 }}>
            📎
          </label>
          <input
            type="file"
            ref={ref}
            accept=".csv"
            onChange={handleChange}
            id={id}
            style={{
              display: 'none',
            }}
          />
        </Button>
      )}
      {!!filename && (
        <>
          <b>{filename}</b>
          &nbsp;
          <span>({displayBytes(filesize || 0)})</span>
          &nbsp;&nbsp;
          <Button variant="primary" onClick={handleReset}>
            Reset
          </Button>
        </>
      )}
    </>
  );
};

const displayBytes = (bytes: number) => {
  if (bytes > 1000000000) {
    return (bytes / 1000000000).toFixed(2) + 'GB';
  }
  if (bytes > 1000000) {
    return (bytes / 1000000).toFixed(2) + 'MB';
  }
  if (bytes > 1000) {
    return (bytes / 1000).toFixed(2) + 'KB';
  }
  return bytes + ' bytes';
};
